import React from 'react';
import { Box, Flex, Text } from '@radix-ui/themes';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectDevice } from 'store/slices/common';

import './style.scss';

export default function NoData() {
  const { pathname } = useLocation();
  const path = pathname.replace('/', '');

  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';

  return (
    <>
      {path === 'localCenter' ? (
        <Flex direction="column" align="center" justify="center" mt={'var(--space-10)'} className="no-data-wrap">
          <Box>
            <img src={require('assets/images/common/no-select-local.png')} alt="데이터 없음" />
          </Box>
          <Text as="p" mt={isMobile ? 'var(--space-6)' : 'var(--space-10)'} className={isMobile ? 'sub-title' : 'title5'}>
            지역을 선택해 주세요.
          </Text>
          <Text as="p" mt={isMobile ? 'var(--space-2)' : 'var(--space-4)'} className={`body${isMobile ? '3' : '2'} font-basic`}>
            각 센터별 교육정보를 확인할 수 있습니다.
          </Text>
        </Flex>
      ) : (
        <Box mt="var(--space-2)" className="empty-page-wrap">
          <Flex direction="column" align="center" justify="center" gap="var(--space-5)" className="no-data" py="196px">
            <Box>
              <img src={require('assets/images/icon/icon-nodata.svg').default} alt="데이터 없음" />
            </Box>
            <Text as="p" color="gray" className="body1">
              데이터가 없습니다.
            </Text>
          </Flex>
        </Box>
      )}
    </>
  );
}
